// 大雷网站 · 编辑部内容数据（静态展示用）
export const navSections = [
  { label: "雷点整理", href: "#leidian" },
  { label: "吃瓜清单", href: "#qingdan" },
  { label: "事件脉络", href: "#mailuo" },
  { label: "吃瓜现场", href: "#changchang" },
  { label: "劲爆盘点", href: "#toutiao" },
];

export const heroTags = [
  "顶流又双叒塌",
  "直播间翻车回放",
  "恋综剧本穿帮",
  "售后跑路上热搜",
  "合约撕破脸",
  "人设当场爆缸",
];

export const heroCover =
  "https://readdy.ai/api/search-image?query=Premium%20editorial%20magazine%20cover%20illustration%20in%20bold%20Chinese%20crimson%20red%20and%20warm%20amber%20tones%2C%20an%20abstract%20flat%20collage%20of%20a%20golden%20megaphone%20blasting%20glossy%20speech%20bubbles%20and%20torn%20paper%20strips%20with%20radiating%20halftone%20lines%2C%20clean%20paper-white%20background%20with%20generous%20negative%20space%2C%20sophisticated%20contemporary%20media%20design%2C%20premium%20print%20aesthetic%2C%20high%20contrast%2C%20no%20text&width=900&height=1200&seq=hero-cover-2026&orientation=portrait";

export const featureItem = {
  kicker: "本期劲爆盘点 · 大瓜合集 No.038",
  titleA: "三周内连爆三雷，",
  titleB: "这次塌得有点彻底",
  lead: "从一场直播翻车开始，到售后烂尾收场，中间还穿插了一次人设反转。编辑部把完整事件脉络摊开：每一段来龙去脉都标了实锤与存疑，吃过一遍就能跟人聊到点上。",
  cover:
    "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photojournalism%20scene%20of%20a%20dramatic%20stage%20with%20warm%20amber%20spotlight%20cutting%20through%20dark%20crimson%20haze%2C%20floating%20torn%20newspaper%20pages%20and%20soft%20blurred%20silhouettes%2C%20moody%20high-contrast%20magazine%20spread%2C%20deep%20red%20and%20gold%20palette%2C%20artistic%20abstract%20documentary%20feel%2C%20rich%20texture%2C%20no%20visible%20faces&width=1600&height=900&seq=feature-big-01&orientation=landscape",
  chips: ["直播翻车", "人设反转", "售后烂尾"],
  statReads: "186万",
  statComments: "9.4万",
  issue: "事件脉络完整版",
};

// 雷点整理 —— 分类目录
export const categories = [
  {
    key: "live",
    index: "01",
    tab: "直播间翻车",
    headline: "话术没兜住，当场爆缸",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20flat%20editorial%20vector%20of%20a%20gold%20microphone%20shattering%20into%20scattered%20pixel%20shards%20and%20warning%20sparks%2C%20warm%20crimson%20and%20amber%20palette%20on%20clean%20ivory%20background%2C%20magazine%20print%20style%2C%20subtle%20grainy%20paper%20texture%2C%20strong%20central%20composition%2C%20no%20text&width=900&height=600&seq=cat-live-01&orientation=landscape",
    desc: "喊错参数、报错库存、怼错人。我们把每一场社死现场按时间轴扒清，谁先破防、谁来救场、最后谁背了锅。",
    points: [
      { tag: "实锤", text: "限时秒杀价格被喊成对折，后台当场被冲爆，弹幕全在刷『已截图』。" },
      { tag: "存疑", text: "所谓‘系统故障回滚’，究竟是技术问题还是出货预算超支，双方说法仍对不上。" },
      { tag: "后续", text: "隔天补发致歉公告，评论区却开始反向玩梗，把翻车片段做成了二创。" },
    ],
  },
  {
    key: "persona",
    index: "02",
    tab: "人设塌房",
    headline: "叠满的人设，一碰就碎",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20flat%20editorial%20vector%20of%20a%20tall%20jenga%20tower%20of%20stacked%20porcelain%20theater%20masks%20toppling%20over%2C%20one%20mask%20cracking%2C%20warm%20crimson%20red%20and%20gold%20palette%20on%20clean%20ivory%20background%2C%20magazine%20print%20style%2C%20grainy%20paper%20texture%2C%20central%20composition%2C%20no%20text&width=900&height=600&seq=cat-persona-01&orientation=landscape",
    desc: "学霸、清贫、敬业、宠粉……人设叠得越满，摔得越响。我们把每一层‘人设积木’抽出来，看看哪一根先松了。",
    points: [
      { tag: "起底", text: "早年采访里那句『我从不熬夜』，被考古出三年通宵赶工的现场旧照。" },
      { tag: "对质", text: "前同事匿名投稿与公开履历时间线冲突，编辑部逐条比对后列成对照表。" },
      { tag: "反转", text: "原以为实锤的爆料，因一纸票据日期出错，反而帮当事人扳回一局。" },
    ],
  },
  {
    key: "script",
    index: "03",
    tab: "剧本穿帮",
    headline: "演得太假，观众先笑",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20flat%20editorial%20illustration%20of%20a%20clapperboard%20splitting%20open%20revealing%20tangled%20red%20script%20threads%20and%20a%20dangling%20stage%20curtain%2C%20warm%20amber%20and%20crimson%20palette%20on%20clean%20ivory%20background%2C%20magazine%20print%20style%2C%20central%20composition%2C%20no%20text&width=900&height=600&seq=cat-script-01&orientation=landscape",
    desc: "恋综的偶遇、商战的对赌、逆袭的起点，都可能是分镜脚本。我们盯帧对比，把‘巧合’里藏好的机位挑出来。",
    points: [
      { tag: "盯帧", text: "慢镜头下，一句‘偶遇’背后同款路人包出现三集，机位还被找到了同一面墙。" },
      { tag: "串场", text: "角色口中‘第一次来’的餐厅，被扒出节目录制前已连续打卡七天。" },
      { tag: "幕后", text: "某导演手滑点赞编剧群截图，片名之下，原来每场转折都有编号提示。" },
    ],
  },
  {
    key: "material",
    index: "04",
    tab: "物料造假",
    headline: "一张图也能翻车",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20flat%20editorial%20illustration%20of%20crumpled%20forged%20paper%20receipts%20and%20a%20bent%20rubber%20stamp%20spilling%20golden%20dust%2C%20warm%20red%20and%20amber%20palette%20on%20clean%20ivory%20background%2C%20magazine%20print%20style%2C%20central%20composition%2C%20no%20text&width=900&height=600&seq=cat-material-01&orientation=landscape",
    desc: "P图、旧图、跨年复用。物料造假的翻车往往最小，却最容易让一句澄清彻底失去信用。",
    points: [
      { tag: "对比", text: "被指造假的销量海报，与上月版本只差一个数字，连字体间距都一模一样。" },
      { tag: "溯源", text: "所谓‘实地拍摄’的原图，被从素材网站按像素找到了购买记录。" },
      { tag: "代价", text: "澄清越硬、被扒越狠，最后官方只能沉默删博，留下满屏已读不回。" },
    ],
  },
  {
    key: "service",
    index: "05",
    tab: "售后烂尾",
    headline: "买前大爷，售后失踪",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20flat%20editorial%20graphic%20of%20an%20unfinished%20brick%20wall%20with%20a%20red%20paused%20sign%20and%20a%20dangling%20unplugged%20cable%2C%20warm%20amber%20and%20crimson%20palette%20on%20clean%20ivory%20background%2C%20magazine%20editorial%20style%2C%20central%20composition%2C%20no%20text&width=900&height=600&seq=cat-service-01&orientation=landscape",
    desc: "客服已读、换货断货、退款排到下月。我们把被‘售后黑洞’吞掉的真实诉求，按周整理成一张催办榜。",
    points: [
      { tag: "实录", text: "同一句自动回复连发八次，人工客服的排号从本周排到了下下周三。" },
      { tag: "断点", text: "承诺的七天无理由，卡在‘需先寄回赠品’这一步，赠品至今没到货。" },
      { tag: "催办", text: "投诉帖冲上热榜后，账号才恢复‘已读’，售后话术瞬间变得客气。" },
    ],
  },
  {
    key: "quality",
    index: "06",
    tab: "偷工减料",
    headline: "参数没少，实物拉胯",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20flat%20editorial%20illustration%20of%20a%20bargain%20package%20box%20cracking%20open%20with%20cheap%20plastic%20filler%20tumbling%20out%2C%20warm%20red%20and%20amber%20palette%20on%20clean%20ivory%20magazine%20background%2C%20print%20style%2C%20central%20composition%2C%20no%20text&width=900&height=600&seq=cat-quality-01&orientation=landscape",
    desc: "宣发图里金光闪闪，开箱之后一地鸡毛。参数与实物的落差，是我们雷点整理最常蹲到的坑。",
    points: [
      { tag: "开箱", text: "标称‘航空级’的材质，被第三方送检后标注为普通塑料，报告编号可查。" },
      { tag: "比例", text: "详情页放大的功能卖点，在实际评测里只占了整机三成的使用率。" },
      { tag: "退路", text: "客服称‘批次差异’，但同批次的独立测评账号，翻车结果却出奇一致。" },
    ],
  },
];

// 吃瓜清单 —— 本周必吃
export const listicleItems = [
  {
    rank: "01",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20editorial%20flat%20vector%20of%20a%20golden%20bell%20bursting%20open%20with%20ribbons%20and%20confetti%20shooting%20outward%2C%20warm%20amber%20and%20crimson%20palette%20on%20clean%20ivory%20background%2C%20tall%20magazine%20cover%20style%2C%20central%20composition%2C%20no%20text&width=800&height=1000&seq=guac-01&orientation=portrait",
    title: "深夜炸弹：合同比感情先到期",
    lead: "一份被‘手滑’晒出的续约条款，让整个粉丝群连夜加班研读，连标点符号都没放过。",
    meta: "爆了 2.3万 条 · 讨论 11 个群",
    label: "爆料汇总",
  },
  {
    rank: "02",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20editorial%20flat%20vector%20of%20a%20red%20target%20bullseye%20with%20a%20golden%20dart%20hitting%20dead%20center%20with%20impact%20star%20burst%2C%20warm%20crimson%20and%20amber%20palette%20on%20clean%20ivory%20tall%20magazine%20background%2C%20central%20composition%2C%20no%20text&width=800&height=1000&seq=guac-02&orientation=portrait",
    title: "实锤落靶：这次不是营销号乱讲",
    lead: "聊天记录、转账流水、时间线截图三件套到齐，连吃瓜老手都点头说‘这波稳了’。",
    meta: "实锤 86 处 · 反转 0 次",
    label: "事件脉络",
  },
  {
    rank: "03",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20editorial%20flat%20vector%20of%20a%20balanced%20golden%20scale%20with%20two%20glowing%20light%20orbs%20on%20each%20side%20and%20soft%20rays%2C%20warm%20amber%20and%20crimson%20palette%20on%20clean%20ivory%20tall%20magazine%20background%2C%20central%20composition%2C%20no%20text&width=800&height=1000&seq=guac-03&orientation=portrait",
    title: "一夜反转：被锤的人反手掏证据",
    lead: "谁也没想到，白天还在道歉的一方，晚上贴出的旧记录让整条瓜线彻底改道。",
    meta: "反转 ×2 · 站队 6.7万人",
    label: "吃瓜清单",
  },
  {
    rank: "04",
    cover:
      "https://readdy.ai/api/search-image?query=Premium%20editorial%20flat%20vector%20of%20a%20glowing%20candle%20casting%20warm%20gold%20light%20with%20a%20gentle%20checkmark%20floating%20above%20flame%2C%20calm%20amber%20and%20soft%20crimson%20palette%20on%20clean%20ivory%20tall%20magazine%20background%2C%20central%20composition%2C%20no%20text&width=800&height=1000&seq=guac-04&orientation=portrait",
    title: "尘埃落定：闹了三天，一句道歉收尾",
    lead: "当事双方各退一步，声明连标点都斟酌过。这场大瓜走到这儿，总算给了个能下场台阶。",
    meta: "落地 · 全网 8.9万 条跟评",
    label: "劲爆盘点",
  },
];

// 事件脉络 —— 一条大瓜的来龙去脉
export const timeline = {
  kicker: "事件脉络 · 深度复盘",
  title: "那条‘三天三反转’的大瓜，到底怎么走到今天的",
  meta: "单瓜脉络 · 全网热议事件 · 编辑部持续追踪",
  events: [
    {
      time: "第 1 天 · 09:12",
      tone: "起",
      title: "一张截图先点燃了导火索",
      text: "某群匿名投稿流出截图，称双方合作早在三个月前就已闹僵，措辞火药味十足。",
      count: "跟帖 1.2万",
    },
    {
      time: "第 1 天 · 22:47",
      tone: "锤",
      title: "实锤开始排队进场",
      text: "运营号、物料、时间线先后被扒，越来越多二手证据指向同一个结论。",
      count: "跟帖 3.6万",
    },
    {
      time: "第 2 天 · 14:30",
      tone: "转",
      title: "当事人下场，第一轮反转",
      text: "一方晒出完整记录，把此前指向自己的证据逐条拆解，评论区风向瞬间倒转。",
      count: "跟帖 5.1万",
    },
    {
      time: "第 2 天 · 23:05",
      tone: "再转",
      title: "被晒的截图，查出是旧账",
      text: "编辑部按日期核验后发现，所谓‘完整记录’漏掉了最关键的最近三个月。",
      count: "跟帖 6.8万",
    },
    {
      time: "第 3 天 · 11:20",
      tone: "定",
      title: "道歉声明，给事件收了个尾",
      text: "双方联合声明与限时承诺一起发出，这场拉锯终于有了一个说得过去的句号。",
      count: "跟帖 8.9万",
    },
  ],
};

// 吃瓜现场 —— 评论与站队
export const commentStacks = [
  {
    name: "二狗今天也不上班",
    badge: "高赞 · 1.2万",
    text: "我从第一张截图就开始蹲，这瓜每反转一次，我都要重新站一次队，血压比甲方还高。",
    likes: 12140,
    replies: 312,
  },
  {
    name: "热心市民瓜友A",
    badge: "铁口直断",
    text: "早说过会烂尾，营销话术和售后态度根本不是一回事，这下全对上了吧。",
    likes: 8760,
    replies: 205,
  },
  {
    name: "理性吃瓜中",
    badge: "新锐观点",
    text: "别急着下场，先把那三个月的时间线捋明白再站队，反转通常藏在这儿。",
    likes: 6450,
    replies: 158,
  },
];

export const poll = {
  question: "这波站队你选谁？",
  options: [
    { key: "A", label: "信实锤，先站反方", pct: 58, votes: "3.1万" },
    { key: "B", label: "再看看，蹲个完整脉络", pct: 31, votes: "1.6万" },
    { key: "C", label: "都是剧本，散了吧", pct: 11, votes: "0.6万" },
  ],
};

// 热雷指数 —— 劲爆盘点榜单
export const hotTrends = [
  { rank: 1, title: "直播间‘手滑’降级价，全场直接爆单又爆雷", hot: 98, tag: "直播间翻车" },
  { rank: 2, title: "恋综名场面被扒出分镜脚本，连站位都算好了", hot: 92, tag: "剧本穿帮" },
  { rank: 3, title: "顶流合约纠纷升级，评论区开始分山头", hot: 88, tag: "人设塌房" },
  { rank: 4, title: "被锤品牌晒‘完整记录’，却被查出三个月旧账", hot: 84, tag: "事件反转" },
  { rank: 5, title: "七天无理由卡在寄回赠品，售后黑洞再上热榜", hot: 79, tag: "售后烂尾" },
  { rank: 6, title: "宣发图金光闪闪，开箱测评却一地鸡毛", hot: 73, tag: "偷工减料" },
];

export const trendingChip = {
  A: "直播翻车",
  B: "剧本穿帮",
  C: "人设塌房",
  D: "事件反转",
  E: "售后烂尾",
  F: "偷工减料",
};

// 页脚栏目索引
export const footerColumns = [
  {
    title: "内容栏目",
    links: [
      { label: "雷点整理", href: "#leidian" },
      { label: "吃瓜清单", href: "#qingdan" },
      { label: "事件脉络", href: "#mailuo" },
      { label: "吃瓜现场", href: "#changchang" },
      { label: "热雷指数榜", href: "#baoliao" },
    ],
  },
  {
    title: "编辑部专栏",
    links: [
      { label: "劲爆盘点", href: "#toutiao" },
      { label: "爆料汇总", href: "#qingdan" },
      { label: "一周瓜报", href: "#changchang" },
      { label: "榜单合集", href: "#baoliao" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "站务说明", href: "#" },
      { label: "投稿须知", href: "#" },
      { label: "事实核查", href: "#" },
      { label: "联系方式", href: "#" },
    ],
  },
];